import React, { useState, useEffect } from 'react';
import { Table, Row, Col, Spinner } from 'react-bootstrap';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ScorerTable = ({ title, scorers }) => (
    <div style={{ overflowX: 'auto', maxWidth: 700, marginLeft: 'auto', marginRight: 'auto' }}>
        <h5 className="text-center">{title}</h5>
        <Table striped bordered hover className="sticky-col-2" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            <thead>
            <tr>
                <th>#</th>
                <th>Imię i nazwisko</th>
                <th>Zespół</th>
                <th>Bramki</th>
            </tr>
            </thead>
            <tbody>
            {(scorers || []).map((player, index) => (
                <tr key={index}>
                    <td>{player.position + "."}</td>
                    <td>{player.first_name + " " + player.last_name}</td>
                    <td>{player.team_name}</td>
                    <td>{player.goals}</td>
                </tr>
            ))}
            </tbody>
        </Table>
    </div>
);

const GoalscorersTable = ({ season }) => {
    const [goalscorers, setGoalscorers] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${BACKEND_URL}/tables/goalscorers?season=${season}`);
                setGoalscorers(response.data);
            } catch {
                setGoalscorers({});
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [season]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Ładowanie...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <Row>
            <Col md={6}>
                <ScorerTable title="Liga" scorers={goalscorers.league} />
            </Col>
            <Col md={6}>
                <ScorerTable title="Puchar Ligi" scorers={goalscorers.cup} />
            </Col>
        </Row>
    );
};

export default GoalscorersTable;